import React from 'react';
import {
  AppLayout,
  ContentLayout,
  Header,
  Button,
  SpaceBetween
} from '@cloudscape-design/components';

function App() {
  return (
    <AppLayout
      toolsHide={true}
      content={
        <ContentLayout header={<Header variant="h1">A1Ultra</Header>}>
          <SpaceBetween size="m">
            <p>We build AI-driven Algo Trading solutions.</p>
            <Button variant="primary">Learn More</Button>
            <Button>Wiki</Button>
            <Button>Trading App</Button>
          </SpaceBetween>
        </ContentLayout>
      }
      navigationHide={true}
    />
  );
}

export default App;